<template>
  <div class="card">
    <header class="card-header">
      <ul class="tab-heads">
        <li
          v-for="tab in tabs"
          :key="tab"
          class="tab-head"
          :class="{
            'tab-head--active': selectedTab === tab
          }"
          @click="switchTab(tab);"
        >
          <slot :name="tabHeadSlotName(tab)">{{ selectedTab }} </slot>
        </li>
      </ul>
      <button class="button is-info recipeLoadButton" @click="$emit('pack')">Pack it &rarr;</button>
    </header>
    <main class="card-body">
      <div class="tab-panel"><slot :name="tabPanelSlotName" /></div>
    </main>
  </div>
</template>

<script>

export default {
  props: {
    initialTab: String,
    tabs: Array
  },
  data () {
    return {
      currentTab: ''
    }
  },
  computed: {
    tabPanelSlotName () {
      return `tab-panel-${this.selectedTab}`
    },
    selectedTab () {
      if (this.currentTab === '') {
        return this.initialTab
      }
      return this.currentTab
    }
  },
  watch: {
    // this will only swap the tab from request to visual
    // the _first_ time the pack is run. subsequent ones
    // will not change the initialTab prop, so they
    // will stay on the tab selected.
    initialTab () {
      this.currentTab = ''
    }
  },
  methods: {
    tabHeadSlotName (tabName) {
      return `tab-head-${tabName}`
    },

    switchTab (tabName) {
      this.currentTab = tabName
    }
  }
}
</script>

<style scoped>
.recipeLoadButton{
    display: flex;
    position: absolute;
    right: 15px;
    top: 10px;
    background: #ee4a9b;
  }
.card {
  background-color: #fff;
  border-radius: 6px;
  height: 545px;
  box-shadow: 2px 0px 30px 0 rgba(0, 0, 0, 0.14);
}

.card-header {
  background: #322763 url(~assets/thePlight.png) no-repeat;
  background-position: right 130px center;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  color: #fff;
  padding: 30px 8px 0;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  box-shadow: none;
}

.tab-heads {
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;
  margin-left: 6px;
  margin-top: -4px;
}

#singlePost ul.tab-heads{
  padding-bottom: 0em;
}

.tab-head {
  padding: 5px 18px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  position: relative;
  cursor: pointer;
}

#singlePost li.tab-head{
  list-style-type: none;
  color: #FFF;
  /* padding-left: 0em; */
  margin-left: 0em;
  margin-bottom: 0em;
}

#singlePost li.tab-head--active {
  background-color: #fff;
  color: #333;
  transition: 0.4s;
}

.card-body {
  padding: 20px 16px;
  overflow-y: scroll;
  height: 485px;
}
</style>
